module.exports = __webpack_public_path__ + "img/无差异@3x.ee1fb804.png";